module.exports = __webpack_public_path__ + "img/dklogo.cee011c5.png";